import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { BrowserRouter as Router } from "react-router-dom";
import { DataProvider } from "./context/DataContext/DataContext";
import { AuthProvider } from './context/AuthContext/AuthContext';


ReactDOM.render(
  <React.StrictMode>
    <Router>
      <AuthProvider>
    <DataProvider>
    <App />
    </DataProvider>
    </AuthProvider>
    </Router>
    
  </React.StrictMode>,
  document.getElementById('root')
);


